import colors from 'styles/colors'

const styles = {
  modal: {
    content: {
      padding: 0,
      flexDirection: 'column'
    }
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    borderBottom: `1px solid ${colors.unicornSilver}`,
    padding: '1.5em'
  },
  sectionHeader: {
    color: colors.darkStormy,
    fontFamily: 'Barlow',
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: 0,
    lineHeight: '14px'
  },
  toggle: {
    container: {
      marginTop: 22
    }
  },
  additionalBlock: {
    marginTop: 20,
    marginBottom: -40
  }
}

styles.lastSection = { ...styles.section, borderBottom: 'none', paddingBottom: 50 }
styles.errorText = { ...styles.additionalBlock, fontFamily: 'Barlow' }
styles.loadingContainer = {
  ...styles.additionalBlock,
  position: 'relative',
  marginTop: 20,
  marginBottom: -40,
  height: 20,
  width: 20
}

export default styles
